import { getBlob } from 'firebase/storage';
import { firebase_app } from '../Config/Config';

const HTTP_URL_PATTERN = /^https?:\/\//i;
const GS_URL_PATTERN = /^gs:\/\//i;
const CANONICAL_STORAGE_PATH_PATTERN = /^clients\/[^/]+\/tickets\/[^/]+\/photos\/[^/]+$/i;

export const resolveTicketPhotoUrl = async (photoReference, storage) => {
  const reference = typeof photoReference === 'string' ? photoReference.trim() : '';

  if (!reference) {
    throw new Error('Photo reference is empty');
  }

  if (HTTP_URL_PATTERN.test(reference)) {
    return { kind: 'borrowed', url: reference };
  }

  const isGsReference = GS_URL_PATTERN.test(reference);
  const isCanonicalPath = CANONICAL_STORAGE_PATH_PATTERN.test(reference);

  if (!isGsReference && !isCanonicalPath) {
    return { kind: 'borrowed', url: reference };
  }

  const photoStorage = storage || firebase_app.storage();
  const storageReference = isGsReference
    ? photoStorage.refFromURL(reference)
    : photoStorage.ref(reference);

  return {
    kind: 'blob',
    blob: await getBlob(storageReference),
  };
};
